import React from "react";
import { Accordion } from "react-bootstrap";
import TestItem from "./TestItem";
import "../../Practice/components/TopicItem.css";

const DesktopView = ({
  topicsList,
  selectedTopic,
  renderTestButton,
  focusedExam,
}) => {
  return (
    <div className="d-none d-lg-block col-8" style={{ marginTop: "15px" }}>
      {topicsList.length
        ? topicsList.map((topic, index) => {
            // Badge logic copied from TopicItem.js
            const isValidScore = (score) =>
              typeof score === "number" && !isNaN(score);
            const allTestsAttempted = Array.isArray(topic?.tests)
              ? topic.tests.length > 0 &&
                topic.tests.every((t) => isValidScore(t.score))
              : true; // If no tests, treat as true
            const hasAnySets =
              Array.isArray(topic?.tests) && topic.tests.length > 0;
            const allAttempted = hasAnySets && allTestsAttempted;
            const topicScore =
              typeof topic.score === "string"
                ? parseFloat(topic.score)
                : topic.score;
            let badge = null;
            if (allAttempted) {
              if (topicScore >= 90) badge = "Champion";
              else if (topicScore > 60 && topicScore < 90) badge = "Challenger";
              else badge = "Rookie";
            } else {
              if (topicScore > 60) badge = "Challenger";
              else badge = "Rookie";
            }
            return (
              <div
                key={`topic-index-${index}`}
                id={topic?._id}
                className="mb-4 d-flex align-items-center"
              >
                <Accordion
                  className="categoriesAccordion w-100"
                  style={{
                    boxShadow:
                      selectedTopic === topic?._id
                        ? "0 0 6px rgba(35, 173, 278, 1)"
                        : "",
                  }}
                >
                  <Accordion.Item className="bg-white">
                    <Accordion.Header>
                      <div className="d-flex flex-column bg-white p-2">
                        <div className="d-flex align-items-center gap-2">
                          <strong style={{ fontSize: "20px" }}>
                            {topic?.name}
                          </strong>
                          {badge && (
                            <span
                              className={`topic-badge ${badge.toLowerCase()}`}
                            >
                              {badge}
                            </span>
                          )}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="p-0">
                      {topic?.tests?.length ? (
                        <div>
                          {topic?.tests.map((test, testInd) => (
                            <TestItem
                              key={testInd}
                              test={test}
                              testInd={testInd}
                              topic={topic}
                              renderTestButton={renderTestButton}
                              focusedExam={focusedExam}
                            />
                          ))}
                        </div>
                      ) : (
                        <p
                          className="px-4 py-3"
                          style={{ color: "#6E7485", fontSize: "12px" }}
                        >
                          No tests found.
                        </p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            );
          })
        : ""}
    </div>
  );
};

export default DesktopView;
